import {
  STATUS,
  MASTERDATA_NAME,
  ADDITIONAL_COL,
  fieldTypes,
  TYPE,
  excludedColumns,
  typesByColId,
  fieldsMap
} from '../constants'
import {
  getScenarioColumns,
  getStandardColumnDefs
} from 'pages/Scenario/Manager/utils/table'

export const getOptionsByFieldMap = (
  scenarioStatuses,
  scenarioTypes,
  scenarioInstances
) => ({
  [fieldsMap[STATUS]]: scenarioStatuses,
  [fieldsMap[TYPE]]: scenarioTypes,
  [fieldsMap[MASTERDATA_NAME]]: scenarioInstances
})

export const buildRulesConfig =
  ({
    t,
    additionalColumns,
    scenarioTypes,
    scenarioInstances,
    scenarioStatuses
  }) =>
  () => {
    const remappedColIds = [
      ...getScenarioColumns(t),
      ...getStandardColumnDefs(t)
    ].map((col) => ({ ...col, colId: fieldsMap[col.colId] ?? col.colId }))

    const columns = [
      ...remappedColIds,
      ...additionalColumns.map((col) => ({
        ...col,
        headerName: t(`Wizard:Scenario.${col?.label}`),
        colId: col?.field,
        type: ADDITIONAL_COL
      }))
    ]

    const optionsByFieldMap = getOptionsByFieldMap(
      scenarioStatuses,
      scenarioTypes,
      scenarioInstances
    )
    const filteredColumns = columns.filter(
      ({ colId }) => !excludedColumns.includes(colId)
    )

    const fields = filteredColumns.map(({ colId, headerName }) => ({
      type: typesByColId[colId],
      value: colId,
      label: headerName,
      options: getOptions(colId, optionsByFieldMap)
    }))

    return {
      fields,
      validationUrl: '/purger/validate-query'
    }
  }

const getOptions = (colId, optionsByFieldMap) => {
  if (typesByColId[colId] === fieldTypes.SELECT) {
    // Type(scenarioType) is an object, so in this case we get typeValue

    return optionsByFieldMap[colId].map((key) => ({
      label: key,
      value: key
    }))
  } else return []
}
